import styled from "styled-components"

export const HeaderWrapper = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
	flex-wrap: wrap;
	border-bottom: 2px solid #eaeafd;
	padding-bottom: 33px;
	.containerLabel {
		p {
			margin: 0;
			padding: 0;
			font-weight: 700;
			font-size: 18px;
			line-height: 100%;
			letter-spacing: 0%;
			color: #130080;
		}
	}
`
